import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../../BaseComponent';
import { CatalogActions } from '../../../actions/CatalogActions';

interface CatalogNavigationState {
}

interface CatalogNavigationProps {
    catalogSelectBox: JSX.Element;
    label: string;
    search: boolean;
    inCatalog: boolean;
}

export class CatalogNavigation extends BaseComponent<CatalogNavigationProps, CatalogNavigationState> {
    public render(): JSX.Element | null {
        return (
            <div className="catalog-navigation">
                <div onClick={CatalogActions.leaveCatalogItem} className={'catalog-back' + (this.props.inCatalog ? ' enabled' : '')}/>
                <div className="catalog-separator" style={!this.props.inCatalog ? {marginRight: '10px'} : {}}/>
                {this.props.catalogSelectBox}
                {this.labelElement()}
            </div>
        );
    }

    protected labelElement = (): JSX.Element => {
        if (this.props.search) {
            return (
                <div className="catalog-label">
                    <div className="catalog-label-intro">{t('Search in') + ' "'}</div>
                    <div className="catalog-label-text">{this.props.label}</div>
                    <div className="catalog-label-outro">"</div>
                </div>
            );
        }
        return (
            <div className="catalog-label">{this.props.label}</div>
        );
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/catalog/CatalogNavigation.tsx